import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import './BundleReleaseModal.scss'
import Modal from '../../../../components/Modal'
import Button, { ButtonTheme } from '../../../../components/Form/Button'
import { BundleModel } from '../../../../api/bundle/models/bundle.model'
import BundlesService from '../../services/bundles.service'
import { AppContext } from '../../../../contexts/AppContext'

const BundleReleaseModal: React.FC<{
  bundle?: BundleModel
  isModalOpen: boolean
  setModalOpen: (open: boolean) => void
}> = ({ bundle, isModalOpen, setModalOpen }) => {
  const { t } = useTranslation()
  const { addNotification } = useContext(AppContext)

  const releaseBundle = () => {
    if (!bundle) {
      return
    }

    void BundlesService.releaseBundle(bundle.id, addNotification, t, setModalOpen)
  }

  return (
    <Modal
      title={`${t('bundle.releaseBundle')}`}
      classNameOverlay='BundleReleaseModal'
      isOpen={isModalOpen}
      onClose={(isOpen: boolean) => void setModalOpen(isOpen)}
      footer={
        <div className={'BundleReleaseModal__footer'}>
          <Button
            theme={ButtonTheme.BLUE}
            onClick={releaseBundle}
          >
            {t('bundle.confirm')}
          </Button>
          <Button
            theme={ButtonTheme.BLUE_OUTLINE}
            onClick={() => void setModalOpen(false)}
          >
            {t('common.cancel')}
          </Button>
        </div>
      }
    >
      {isModalOpen && (
        <div>
          <p>{t('bundle.releaseConfirmation')}</p>
        </div>
      )}
    </Modal>
  )
}

export default BundleReleaseModal
